export const APP_MODAL_CORNER_RADIUS = 28;

/** The room the app's grab handle takes at the top of a sheet (its pill,
 *  4pt down, and the space under it): where a sheet's content starts. */
export const APP_MODAL_HANDLE_ROOM = 20;
